// extracted by mini-css-extract-plugin
export default {"skills":"MisSkills_skills__SoT46","skill":"MisSkills_skill__xW15g","skill_icon":"MisSkills_skill_icon__GC1-r"};